import React, { useState } from 'react';
import { Form, Input, InputNumber, Select, DatePicker, Button, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useHealthStore } from '@/stores/useHealthStore';

interface BPFormProps {
  onSuccess?: () => void;
}

const BPForm: React.FC<BPFormProps> = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const addBloodPressure = useHealthStore(state => state.addBloodPressure);

  const handleSubmit = async (values: any) => {
    setLoading(true);
    try {
      await addBloodPressure({
        date: values.date.format('YYYY-MM-DD'),
        systolic: values.systolic,
        diastolic: values.diastolic,
        heartRate: values.heartRate,
        measureTime: values.measureTime,
        notes: values.notes
      });
      message.success('血压记录已保存');
      form.resetFields();
      onSuccess?.();
    } catch (error) {
      message.error('保存失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        date: dayjs(),
        measureTime: 'morning'
      }}
    >
      <Form.Item
        label="测量日期"
        name="date"
        rules={[{ required: true, message: '请选择日期' }]}
      >
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item
        label="测量时间"
        name="measureTime"
        rules={[{ required: true }]}
      >
        <Select
          options={[
            { label: '早上', value: 'morning' },
            { label: '晚上', value: 'evening' }
          ]}
        />
      </Form.Item>

      <Form.Item
        label="收缩压（高压）"
        name="systolic"
        rules={[
          { required: true, message: '请输入收缩压' },
          { type: 'number', min: 50, max: 250, message: '范围 50-250' }
        ]}
      >
        <InputNumber
          style={{ width: '100%' }}
          placeholder="例如：120"
          suffix="mmHg"
        />
      </Form.Item>

      <Form.Item
        label="舒张压（低压）"
        name="diastolic"
        rules={[
          { required: true, message: '请输入舒张压' },
          { type: 'number', min: 30, max: 150, message: '范围 30-150' }
        ]}
      >
        <InputNumber
          style={{ width: '100%' }}
          placeholder="例如：80"
          suffix="mmHg"
        />
      </Form.Item>

      <Form.Item
        label="心率（可选）"
        name="heartRate"
        rules={[{ type: 'number', min: 30, max: 200, message: '范围 30-200' }]}
      >
        <InputNumber
          style={{ width: '100%' }}
          placeholder="例如：75"
          suffix="次/分"
        />
      </Form.Item>

      <Form.Item label="备注" name="notes">
        <Input.TextArea rows={2} placeholder="可选：备注信息" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} icon={<SaveOutlined />} block>
          保存血压记录
        </Button>
      </Form.Item>
    </Form>
  );
};

export default BPForm;
